import React, { useState, useEffect } from "react";
import { Card, Container, Row, Col, Spinner, Form, Button } from "react-bootstrap";
import { DatePicker } from "antd";
import axios from "axios";
import moment from "moment";
import Header from "./Header";

const StudentInfoMonthly = () => {
    const [attendanceData, setAttendanceData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);

    const fetchAttendanceData = async () => {
        const authtoken = localStorage.getItem("token");

        if (!fromDate || !toDate) {
            alert("Please select both From Date and To Date.");
            return;
        }

        setLoading(true);
        try {
            const response = await axios.get(
                `https://api.mirai.healthcare/api/attendance/StudentAttendance/filter-data`,
                {
                    params: {
                        session_id: 10,
                        student_id: 3,
                        from_date: fromDate,
                        to_date: toDate,
                    },
                    headers: {
                        "x-auth": authtoken,
                    },
                }
            );
            if (response.data.success) {
                setAttendanceData(response.data.data);
            } else {
                alert("Failed to fetch attendance data.");
            }
        } catch (error) {
            console.error("Error fetching attendance data:", error);
            alert("An error occurred while fetching attendance data.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Header />
            <div style={{ height: "100px" }} />

            <div className="page-wrapper">
                <Container className="mt-4">
                    <div className="text-center mb-4">
                        <h2 className="fw-bold">Student Monthly Attendance</h2>
                    </div>


                    <Row className="mb-4">
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label className="fw-semibold">From Date</Form.Label>
                                <DatePicker
                                    className="form-control"
                                    placeholder="Select Date"
                                    value={fromDate ? moment(fromDate, "DD-MM-YYYY") : null}
                                    onChange={(date) =>
                                        setFromDate(date ? date.format("DD-MM-YYYY") : null)
                                    }
                                    onFocus={() => setFromDate("")}
                                    disabledDate={(current) => current && current > moment().endOf("day")}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label className="fw-semibold">To Date</Form.Label>
                                <DatePicker
                                    className="form-control"
                                    placeholder="Select Date"
                                    value={toDate ? moment(toDate, "DD-MM-YYYY") : null}
                                    onChange={(date) =>
                                        setToDate(date ? date.format("DD-MM-YYYY") : null)
                                    }
                                    onFocus={() => setToDate("")}
                                    disabledDate={(current) => current && current > moment().endOf("day")}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4} className="d-flex align-items-end">
                            <Button variant="primary" onClick={fetchAttendanceData}>
                                Filter
                            </Button>
                        </Col>
                    </Row>


                    {loading ? (
                        <div className="text-center py-5">
                            <Spinner animation="border" />
                        </div>
                    ) : attendanceData ? (
                        <Row className="justify-content-center">
                            <Col md={8}>
                                <Card className="shadow-sm border rounded-3">
                                    <Card.Body>
                                        <h5 className="fw-bold text-center mb-4">Attendance Summary</h5>
                                        <div className="table-responsive">
                                            <table className="table table-bordered text-center">
                                                <thead className="bg-primary text-white">
                                                    <tr>
                                                        <th>Type</th>
                                                        <th>Count</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className="fw-bold text-primary">Total Days</td>
                                                        <td>{attendanceData.totalDays}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="fw-bold text-success">Present</td>
                                                        <td>{attendanceData.present}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="fw-bold text-danger">Absent</td>
                                                        <td>{attendanceData.absent}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="fw-bold text-warning">Leave</td>
                                                        <td>{attendanceData.leave}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="fw-bold text-secondary">Not Marked</td>
                                                        <td>{attendanceData.notMark}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    ) : (
                        <div className="text-center">
                            <p>No attendance data available.</p>
                        </div>
                    )}
                </Container>
            </div>
        </>
    );
};

export default StudentInfoMonthly;